import {
  Component,
  HostListener,
} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {NgIf} from '@angular/common';
import {EmulatorGibddComponent} from './emulator_gibdd/emulator_gibdd.component';

@Component({
  selector: 'gibdd-ekzamen-page',
  templateUrl: './gibdd_ekzamen.component.html',
  imports: [
    NgIf,
    EmulatorGibddComponent,

  ],
  styleUrl: './gibdd_ekzamen.component.less'
})
export class GibddEkzamenPageComponent {

  start_ekzamen = false;
  render = false

  constructor(private title: Title, private meta: Meta) {}

  ngOnInit(): void {
    this.title.setTitle('Экзамен в формате ГИБДД ГАИ 👨🏼‍💻 ПДД 2026  | Онлайн подготовка | ПДД');

    this.meta.updateTag({
      name: 'description',
      content: `Экзамен в формате ГИБДД ГАИ ПДД 2026. Пройдите онлайн тест с официальными вопросами, узнайте правильный ответ и подробное объяснение.`
    });

    this.meta.updateTag({
      name: 'keywords',
      content: `Экзамен в формате ГИБДД ГАИ, ПДД 2026, экзамен ПДД онлайн, подготовка к экзамену ГИБДД, билеты ПДД`
    });
    this.start_ekzamen = false;

  }
  ngAfterContentInit() {
    this.render = true
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.start_ekzamen == false &&  this.render == true) {
      const target = event.target as HTMLElement;
      if (!target.closest('.global_element')) {
        this.start_ekzamen = true;
      }
    }
  }


}
